




































import { useStore } from '@/utils/use-store';
import { reactive, toRefs, defineComponent, onBeforeMount } from '@vue/composition-api';
import { ServiceFactory } from '@/service/ServiceFactory';

import CouponForm from '@/components/Coupon/CouponForm.vue';
import CommonTable from '@/components/CommonTable.vue';

const CouponService = ServiceFactory.get('coupon');

export default defineComponent({
  name: 'CouponList',

  components: {
    CouponForm,
    CommonTable
  },

  setup(props, context) {
    const store = useStore();
    const { accessToken: token } = store.state.user;
    const state = reactive({
      dialog: false,
      couponList: []
    });


    onBeforeMount(onBeforeMountEventHandler);
    /**
     * Handler for the onBeforeMount event
     * */
    async function onBeforeMountEventHandler() {
      state.couponList = await fetch(token);
    }

    /* TODO: move to composition function */
    /**
     * Fetch coupons from the api
     * @param {string} token
     * @return {Coupon[]}
     * */
    async function fetch(token: string) {
      try {
        const { data } = await CouponService.list(token);
        return data;
      } catch (e) {
        const message: string = e.response ? e.response.data.message || e.response.data.error : e.message;
        throw Error(message);
      }
    }

    /**
     * Handler for the save event
     * @param {any} payload
     * */
    async function saveEventHandler(payload: any) {
      try {
        await CouponService.create({ token, payload });
        closeDialog();
        state.couponList = await fetch(token);
      } catch (e) {
        const message: string = e.response ? e.response.data.message || e.response.data.error : e.message;
        throw Error(message);
      }
    }

    /**
     * Open dialog
     * */
    function openDialog() {
      state.dialog = true;
    }
    /**
     * Close dialog
     * */
    function closeDialog() {
      state.dialog = false;
    }

    return {
      ...toRefs(state),
      openDialog,
      closeDialog,
      saveEventHandler
    };
  }
});
